import { ImageUploader } from "@bigbinary/neeto-image-uploader-frontend";
import { useFormikContext } from "formik";
import { Spinner } from "neetoui";
import { isEmpty } from "ramda";

import { IMAGE_UPLOAD_CONFIG } from "./constants";

const MediaUploader = ({ setIsThumbnailImageModalOpen }) => {
  const {
    values: { thumbnailImageUrl },
    setFieldValue,
    initialValues,
    submitForm,
  } = useFormikContext();

  const handleUpload = file => {
    const { url, signedId } = file;
    setFieldValue("thumbnailImage", signedId);
    setFieldValue("thumbnailImageUrl", url);
    setTimeout(() => {
      setIsThumbnailImageModalOpen(false);
      submitForm();
    });
  };

  if (isEmpty(initialValues)) {
    return <Spinner />;
  }

  return (
    <ImageUploader
      className="h-auto w-full"
      key={thumbnailImageUrl}
      src={thumbnailImageUrl}
      uploadConfig={IMAGE_UPLOAD_CONFIG}
      onUploadComplete={handleUpload}
    />
  );
};

export default MediaUploader;
